// Словарь части 5.4 «Подписки, тикеты, почасовые»: вкладка «Часы», тикеты из сообщения, письма и звонка, отчёт о
// часах. Подключается в `ru.ts` поверх словаря производства.

/** Подписка, часы к оплате и тикеты (ключи `projects.*`). */
export const ruProjectsSupport = {
  support: {
    childTitle: '{title} — поддержка',
    title: 'Подписка',
    statusPending: 'Ждёт сдачи проекта',
    statusActive: 'Идёт',
    statusPaused: 'На паузе',
    statusEnded: 'Закончилась',
    available: 'Доступно',
    availableOf: '{left} из {pool}',
    overBadge: 'Сверх тарифа {hours}',
    warnBadge: 'Потрачено {percent} %',
    perMonth: '{hours} в месяц',
    billingMonth: 'Оплата помесячно',
    billingYear: 'Оплата за год',
    billingMonthShort: 'Помесячно',
    billingYearShort: 'За год',
    price: 'Цена за период',
    burnNever: 'Часы не сгорают',
    burnMonths: {
      one: 'Часы живут {count} месяц',
      few: 'Часы живут {count} месяца',
      many: 'Часы живут {count} месяцев',
      other: 'Часы живут {count} месяца',
    },
    startsOn: 'Старт {date}',
    endsOn: 'Последний день {date}',
    noEnd: 'Бессрочно',
    waitsFor: 'Стартует первого числа после сдачи проекта «{title}»',
    supportOf: 'Поддержка проекта «{title}»',
    orderAction: 'Оформить поддержку',
    orderDialogTitle: 'Поддержка проекта',
    orderLeadPending:
      'Заведётся проект-подписка для клиента с той же командой. Часы начнут начисляться первого числа после сдачи проекта',
    orderLeadDone:
      'Заведётся проект-подписка для клиента с той же командой. Часы начисляются первого числа каждого месяца',
    orderStartsAfter: 'Старт — после сдачи проекта',
    ordered: 'Поддержка оформлена',
    linkedTitle: 'Поддержка',
    monthsTitle: 'По месяцам',
    colMonth: 'Месяц',
    colGranted: 'Начислено',
    colCovered: 'Списано',
    colOver: 'Сверх тарифа',
    colBurned: 'Сгорело',
    colRemaining: 'Остаток',
    colExpires: 'Сгорает',
    empty: 'Начислений ещё нет — первые часы придут {date}',
    emptyPending: 'Начислений нет — подписка ждёт сдачи основного проекта',
    setupTitle: 'Подписка не настроена',
    setupText:
      'Укажите, сколько часов в месяц входит в подписку и с какого месяца она идёт — часы начнут начисляться сами',
    setupAction: 'Настроить подписку',
    setupDialogTitle: 'Подписка',
    setupDialogLead: 'Часы начисляются первого числа каждого месяца и сгорают по правилу из настроек КП',
    hoursField: 'Часов в месяц',
    billingField: 'Оплата',
    priceField: 'Цена за период',
    startField: 'Первый месяц',
    burnField: 'Сгорают через, месяцев',
    burnFieldHint: '0 — часы не сгорают',
    save: 'Сохранить',
    required: 'Обязательное поле',
    saved: 'Подписка сохранена',
    endAction: 'Указать окончание',
    endTitle: 'Окончание подписки',
    endLead: 'После этого дня часы больше не начисляются. Уже начисленные можно тратить до их срока',
    endField: 'Последний день',
    endClear: 'Сделать бессрочной',
    endSaved: 'Окончание сохранено',
    editAction: 'Изменить условия',
    editTitle: 'Условия подписки',
    editLead: 'Новые условия действуют со следующего начисления — уже начисленные часы не меняются',
    tickets: 'Тикеты',
    newTicket: 'Новый тикет',
    report: 'Отчёт',
    hints: {
      burn: {
        title: 'Как сгорают часы',
        text: 'Часы начисляются первого числа. Тратятся сначала те, что сгорают раньше. Остаток считается по подтверждённым часам тикетов, а несписанное сгорает в конце срока',
        example: 'Сгорание через 2 месяца: начисленное в октябре можно тратить до 30 ноября',
      },
      over: {
        title: 'Сверх тарифа',
        text: 'Часы тикетов, на которые не хватило начислений. Работа не блокируется — решает руководитель: допродать часы или учесть в следующем месяце',
      },
    },
  },
  hours: {
    tab: 'Часы',
    title: 'К оплате клиентом',
    hint: {
      title: 'Часы к оплате',
      text: 'Подтверждённые часы задач по месяцам × клиентская ставка специализации — как в почасовом КП, с коэффициентами сделки. Счета выставляются в финансах',
    },
    empty: 'Подтверждённых часов пока нет — они появятся, когда руководитель примет задачи',
    incomplete: 'Не у всех специализаций есть ставка — сумма неполная',
    tasksCount: {
      one: '{count} задача',
      few: '{count} задачи',
      many: '{count} задач',
      other: '{count} задачи',
    },
    reportTitle: 'Отчёт о часах',
    reportEmpty: 'В этом месяце подтверждённых часов нет',
    colTask: 'Задача',
    colHours: 'Часы',
    colAmount: 'Сумма',
    colTariff: 'Из тарифа',
    colOver: 'Сверх тарифа',
    totalHours: 'Всего часов',
    totalAmount: 'К оплате',
    totalGranted: 'Начислено в месяце',
    totalTariff: 'Списано из тарифа',
    totalOver: 'Сверх тарифа',
    reportBurns: 'Остаток {hours} сгорит {date}',
    reportIncomplete: 'Часть задач без клиентской ставки — сумма неполная',
    pdf: 'PDF',
    pdfFailed: 'PDF не собрался — попробуйте ещё раз',
    send: 'Отправить клиенту',
    sendTitle: 'Отправить отчёт клиенту',
    sendLead: 'Отчёт за {month} уйдёт письмом с PDF. Ответ на письмо получит руководитель проекта',
    recipient: 'Кому',
    recipientPlaceholder: 'Контакт клиента',
    noRecipients: 'У контактов клиента нет почты — добавьте её в карточке клиента',
    sendSubmit: 'Отправить',
    sent: 'Отчёт отправлен на {email}',
  },
  ticket: {
    action: 'Создать тикет',
    title: 'Новый тикет',
    lead: 'Тикет попадёт на доску подписки клиента, его часы спишутся с тарифа',
    client: 'Клиент',
    clientPlaceholder: 'Найдите клиента',
    name: 'Что нужно сделать',
    namePlaceholder: 'Например, «Поменять баннер на главной»',
    description: 'Подробности',
    source: 'Источник',
    priority: 'Срочность',
    priorityNormal: 'Обычный',
    priorityUrgent: 'Срочно',
    specialization: 'Специализация',
    specializationPlaceholder: 'Кто будет делать',
    project: 'Подписка',
    noClient: 'Выберите клиента — найдём его подписку',
    noSubscription: 'У клиента нет подписки',
    noSubscriptionText: 'Заведите подписку или создайте задачу в почасовом проекте клиента',
    createSubscription: 'Завести подписку',
    hourlyProject: 'Почасовой проект',
    createTask: 'Создать задачу',
    submit: 'Создать тикет',
    created: 'Тикет «{title}» создан',
    createdTask: 'Задача «{title}» создана',
    open: 'Открыть',
    sourceLink: 'Открыть источник',
    sourceOf: 'Тикет · {source}',
    sources: {
      message: 'Сообщение',
      mail: 'Письмо',
      call: 'Звонок',
      manual: 'В проекте',
    },
    urgent: 'Срочно',
  },
  todaySubscriptions: {
    title: 'Подписки: заканчиваются часы',
    hint: 'Подписки, где потрачен порог часов месяца (по умолчанию 80 %) или часы тикетов вышли за начисленное. Решите с клиентом: допродать часы или перенести работу',
    left: 'осталось {left} из {pool}',
    over: 'сверх тарифа {hours}',
  },
} as const;

/** Уведомления 5.4 (в `projects.notifications`). */
export const ruProjectsSupportNotifications = {
  subscriptionWarnTitle: 'Подписка: потрачено {percent} % часов',
  subscriptionOverTitle: 'Подписка: сверх тарифа {hours}',
  subscriptionBody: 'Проект «{project}» — посмотрите вкладку «Часы»',
  ticketTitle: 'Новый тикет «{title}»',
} as const;

/** Типы уведомлений 5.4 (в `notifications`). */
export const ruProjectsSupportNotificationTypes = {
  typeProjectsSubscriptionWarn: 'Подписка: часы на исходе',
  typeProjectsSubscriptionWarnHint:
    'Раз в месяц, когда в подписке клиента потрачен порог часов (по умолчанию 80 %) — руководителю и ответственному за клиента',
  typeProjectsSubscriptionOver: 'Подписка: сверх тарифа',
  typeProjectsSubscriptionOverHint:
    'Раз в месяц, когда часы тикетов вышли за начисленное — работа не блокируется, решает руководитель',
  typeProjectsTicket: 'Новый тикет',
  typeProjectsTicketHint: 'Менеджер завёл тикет в подписке, которую вы ведёте',
} as const;

/** Пункт ⌘K (в `projects.palette`). */
export const ruProjectsSupportPalette = {
  newTicket: 'Новый тикет',
  ticketKeywords: 'тикет поддержка подписка звонок заявка ticket',
} as const;

/** Ошибки 5.4 (в `errors.projects`). */
export const ruProjectsSupportErrors = {
  subscription_minutes: 'Часов в месяц — от {min} до {max}',
  subscription_burn: 'Сгорание — от 0 до {max} месяцев',
  not_subscription: 'Подписка бывает только у проекта вида «Подписка»',
  subscription_exists: 'У проекта уже есть подписка',
  support_of_subscription: 'Это уже проект-подписка — условия меняются на вкладке «Часы»',
  support_exists: 'Поддержка этого проекта уже оформлена',
  support_start_required: 'Укажите месяц, с которого начинается поддержка',
  support_start_past: 'Поддержка начинается с текущего или следующих месяцев',
  subscription_ended: 'Подписка закончилась — заведите новый проект-подписку',
  no_subscription: 'У клиента нет активной подписки',
  not_hourly: 'Часы к оплате есть у почасовых проектов и подписок',
  report_no_email: 'У контакта нет почты — добавьте её в карточке клиента',
} as const;

/** «История» 5.4 (в `audit`). */
export const ruProjectsSupportAudit = {
  actions: {
    project: {
      support_ordered: 'Оформлена поддержка',
      subscription_started: 'Подписка стартовала',
      subscription_changed: 'Изменены условия подписки',
      subscription_ended: 'Подписка закончилась',
      ticket_created: 'Заведён тикет',
      hours_report_sent: 'Отчёт о часах отправлен клиенту',
    },
  },
  fields: {
    hours: 'Часов в месяц',
    month: 'Месяц',
    to: 'Кому',
  },
} as const;

/** Письмо «Отчёт о часах» (в `letters`). */
export const ruProjectsSupportLetters = {
  hoursReportSubject: '{project}: отчёт о часах за {month}',
  hoursReportPreheader: 'Отчёт о часах за {month} — во вложении',
  hoursReportLead: 'Отправляем отчёт о часах по проекту «{project}» за {month}. PDF — во вложении.',
  hoursReportReply: 'Есть вопросы — ответьте на это письмо, его получит руководитель проекта.',
} as const;
